// @flow

import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import API from "../api/user";
import Config from "../constants/Config";
import actions from "../actions/index.js";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import ClubProfileBody from "../components/organisms/ClubProfileBody";
import NavTabs from "../components/molecules/NavTabs";
import CustomMeta from "../components/atoms/CustomMeta.js";

const ProfileClubs = (): React.Node => {
    const dispatch = useDispatch();
    const [memberships, setMemberships] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const breadcrumbs = [
        {
            title: "My account",
            onClick: () => dispatch(actions.openAccountModal()),
            type: "button",
        },
    ];

    const tabs = [
        {
            to: Config.routes.currentMembership,
            title: "Current",
        },
        {
            to: Config.routes.expiredMembership,
            title: "Expired",
        },
    ];

    React.useEffect((): any => {
        let cancel = false;
        setIsLoading(true);
        API.userGetMyMemberships().then((data: any) => {
            if (!cancel) {
                setMemberships(data);
                setIsLoading(false);
            }
        });
    }, []);

    return (
        <React.Fragment>
            <CustomMeta title="Club Memberships" />

            <HeroProfilePage
                heading="Club memberships"
                breadcrumbs={breadcrumbs}
            />

            {/* TAB NAV - JUST FLAT NAV LINK NAVBAR */}
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 col-md-offset-2 col-md-8">
                        <NavTabs
                            tabs={tabs}
                            className="clubs-profile"
                            cta={{
                                url: "/clubs",
                                title: "Browse all clubs",
                            }}
                        />
                    </div>
                </div>
            </div>

            <Switch>
                <Route
                    exact
                    path={Config.routes.currentMembership}
                    render={() => {
                        return (
                            <ClubProfileBody
                                memberships={memberships.filter(
                                    mem => !mem.is_expired
                                )}
                                type="current"
                                isLoading={isLoading}
                            />
                        );
                    }}
                />

                <Route
                    exact
                    path={Config.routes.expiredMembership}
                    render={() => {
                        return (
                            <ClubProfileBody
                                memberships={memberships.filter(
                                    mem => mem.is_expired
                                )}
                                type="expired"
                                isLoading={isLoading}
                            />
                        );
                    }}
                />
            </Switch>
        </React.Fragment>
    );
};

ProfileClubs.preload = ({ location, passed: { store } }: any): Promise<any> => {
    return Promise.all([
        store.dispatch(actions.fetchPage(location.pathname, location.search)),
    ]);
};

export default ProfileClubs;
